import { isNotNullOrUndefined, validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { useContractRevisePagePlanCreateReasonParam } from './use-contract-revise-page-plan-create-reason-param';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useContractRevisePagePlanCreateReason(contractId: string) {
  const [planCreateReason] = useContractRevisePagePlanCreateReasonParam();

  const { data: validatePlanCreateReason } = useQuery({
    queryKey: queryKeys.contracts(contractId, planCreateReason),
    queryFn: () => {
      validateNotNullOrUndefined(planCreateReason);

      return planCreateReason;
    },
    enabled: isNotNullOrUndefined(planCreateReason),
    suspense: true,
  });

  validateNotNullOrUndefined(validatePlanCreateReason);

  return validatePlanCreateReason;
}
